<template>
  <div class="marketplaceAboutContainer w-100">
    <MarketingRow
      :id="marketplaceAboutContent.top.id"
      :backgroundColor="marketplaceAboutContent.top.backgroundColor"
      :body="marketplaceAboutContent.top.body"
      :noAssetBackground="marketplaceAboutContent.top.noAssetBackground"
      :textSide="marketplaceAboutContent.top.textSide"
      :title="marketplaceAboutContent.top.title"
      :titleType="marketplaceAboutContent.top.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="marketplaceAboutContent.top.title.join(' ')"
          :class="{ overflowImage: marketplaceAboutContent.top.overflowImage, 'contain': marketplaceAboutContent.top.containImage }"
          :src="!isMobile ? marketplaceAboutContent.top.imageUrlDesktop : marketplaceAboutContent.top.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <div class="ourMissionWrapper bg-gradient-light-gray">
      <div class="container">
        <div class="flex-col-center paragraphContentSection largePadding mx-auto">
          <img class="logo mb-10" height="auto" :src="logoUrl" width="100">
          <h4>Our Mission</h4>
          <p class="contentMaxWidth">
            Fanatics Collect proudly honors the heritage of trading cards while introducing new technology to improve our clients’ experience. By providing a trusted and user-friendly marketplace with access to thousands of items from various genres, Fanatics Collect offers clients an exciting opportunity to build their personal collections and invest in a rapidly growing asset class. Fanatics Collect’s innovative bidding technology, third-party auction security, high resolution images, sales history tool, and outstanding customer service offer clients a high-quality experience.
          </p>
        </div>
      </div>
    </div>
    <TripleIconMessage :grayBackground="false" :messages="marketplaceTripleIconMessages" title="The Services" />
    <MarketingRow
      v-for="(
        {
          backgroundColor,
          body,
          bodyIsHTML,
          containImage,
          darkButtonEmit,
          darkButtonLink,
          darkButtonText,
          hasBorderTop,
          id,
          textSide,
          title,
          titleType,
          noAssetBackground,
          overflowImage,
          primaryButtonLink,
          primaryButtonText,
          imageUrlDesktop,
          imageUrlMobile
        }, index
      ) in marketplaceAboutContent.main"
      :id="id"
      :key="`main-${index}`"
      :backgroundColor="backgroundColor"
      :body="body"
      :bodyIsHTML="bodyIsHTML"
      :darkButtonEmit="darkButtonEmit"
      :darkButtonLink="darkButtonLink"
      :darkButtonText="darkButtonText"
      :hasBorderTop="hasBorderTop"
      :noAssetBackground="noAssetBackground"
      :primaryButtonLink="primaryButtonLink"
      :primaryButtonText="primaryButtonText"
      :textSide="textSide"
      :title="title"
      :titleType="titleType"
      @defaultClicked="onDefaultClicked"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="title.join(' ')"
          :class="{ overflowImage: overflowImage, 'contain': containImage }"
          :src="!isMobile ? imageUrlDesktop : imageUrlMobile"
        />
      </template>
    </MarketingRow>

    <!-- Capital Modal -->
    <ModalSlider :show="showCapitalModal" @close="showCapitalModal = false">
      <MarketingRow
        :backgroundColor="marketplaceAboutContent.capitalTop.backgroundColor"
        :body="marketplaceAboutContent.capitalTop.body"
        :noAssetBackground="marketplaceAboutContent.capitalTop.noAssetBackground"
        :textSide="marketplaceAboutContent.capitalTop.textSide"
        :title="marketplaceAboutContent.capitalTop.title"
        :titleType="marketplaceAboutContent.capitalTop.titleType"
      >
        <template v-slot:marketingContent>
          <BImgLazy
            :alt="marketplaceAboutContent.capitalTop.title.join(' ')"
            :class="{ overflowImage: marketplaceAboutContent.capitalTop.overflowImage, 'contain': marketplaceAboutContent.capitalTop.containImage }"
            :src="!isMobile ? marketplaceAboutContent.capitalTop.imageUrlDesktop : marketplaceAboutContent.capitalTop.imageUrlMobile"
          />
        </template>
      </MarketingRow>
      <div class="bg-gradient-light-gray">
        <div class="container">
          <div class="flex-col-center paragraphContentSection largePadding mx-auto">
            <h4>Vault Loans</h4>
            <div class="doubleStatWrapper flex-center">
              <div class="doubleStat flex-col-center">
                <h4>1%</h4>
                <span>Monthly Interest Paid</span>
              </div>
              <div class="doubleStat flex-col-center">
                <h4>90 Day</h4>
                <span>Terms</span>
              </div>
            </div>
            <p class="contentMaxWidth">
              Vault Members can request a loan on their portfolio's conservative market value, using their trading card assets as collateral. Fanatics Collect will loan clients up to 40% of their assets’ value at an interest rate of 1% per month, a 90-day term with optional renewal. A 1% origination fee may apply.
            </p>
            <a class="btn btn-dark" :href="vaultEmail">
              Request
            </a>
          </div>
        </div>
      </div>
      <MarketingRow
        v-for="(
          {
            backgroundColor,
            body,
            bodyIsHTML,
            containImage,
            darkButtonEmit,
            darkButtonLink,
            darkButtonText,
            hasBorderTop,
            textSide,
            title,
            titleType,
            noAssetBackground,
            overflowImage,
            primaryButtonLink,
            primaryButtonText,
            imageUrlDesktop,
            imageUrlMobile
          }, index
        ) in marketplaceAboutContent.capitalMain"
        :key="`capital-main-${index}`"
        :backgroundColor="backgroundColor"
        :body="body"
        :bodyIsHTML="bodyIsHTML"
        :darkButtonEmit="darkButtonEmit"
        :darkButtonLink="darkButtonLink"
        :darkButtonText="darkButtonText"
        :hasBorderTop="hasBorderTop"
        :noAssetBackground="noAssetBackground"
        :primaryButtonLink="primaryButtonLink"
        :primaryButtonText="primaryButtonText"
        :textSide="textSide"
        :title="title"
        :titleType="titleType"
        @defaultClicked="onDefaultClicked"
      >
        <template v-slot:marketingContent>
          <BImgLazy
            :alt="title.join(' ')"
            :class="{ overflowImage: overflowImage, 'contain': containImage }"
            :src="!isMobile ? imageUrlDesktop : imageUrlMobile"
          />
        </template>
      </MarketingRow>
      <div class="bg-gradient-light-gray">
        <div class="container">
          <div class="flex-col-center paragraphContentSection largePadding mx-auto">
            <h4>Capital Notes</h4>
            <div class="doubleStatWrapper flex-center">
              <div class="doubleStat flex-col-center">
                <h4>6-9%</h4>
                <span>Monthly Interest Paid</span>
              </div>
              <div class="doubleStat flex-col-center">
                <h4>12</h4>
                <span>Month Periods</span>
              </div>
            </div>
            <p class="contentMaxWidth">
              Exclusively available to Fanatics Collect clients. Fanatics Collect issues Capital Notes to fund marketplace advances and vault loans throughout the year. We will notify clients when we make them available. The notes pay 6-9% interest for a 12-month period. Capital Notes allow clients to earn interest at a fixed rate during a set time frame to diversify their assets.
            </p>
            <a class="btn btn-dark" :href="capitalEmail">
              Request
            </a>
          </div>
        </div>
      </div>
    </ModalSlider>
  </div>
</template>

<script>
import { BImgLazy } from 'bootstrap-vue';
import TripleIconMessage from './TripleIconMessage.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import ModalSlider from './ModalSlider.vue';
import { marketplaceAboutContent, marketplaceTripleIconMessages } from '../constants/marketplaceConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'MarketplaceAbout',
  components: {
    BImgLazy,
    MarketingRow,
    ModalSlider,
    TripleIconMessage,
  },
  mixins: [baseIsMobile],
  data() {
    return {
      marketplaceAboutContent,
      marketplaceTripleIconMessages,
      showCapitalModal: false,
      showEyeModal: false,
      requestEmailAddress: jsConfig.links.requestEmailAddress,
      imagesUrl: jsConfig.links.imagesUrl
    };
  },
  computed: {
    emailAddressHref() {
      return `mailto:${this.requestEmailAddress}`;
    },
    employeeCollageUrl() {
      return this.imagesUrl + 'employee-collage.png';
    },
    logoUrl() {
      return this.imagesUrl + 'logos/fanatics-logo-small.png';
    },
    vaultEmail() {
      return this.emailAddressHref + '?subject=Vault Loan Request';
    },
    capitalEmail() {
      return this.emailAddressHref + '?subject=Capital Note Request';
    }
  },
  methods: {
    onDefaultClicked(modalType) {
      switch (modalType) {
        case 'eyeAppealModal':
          this.showEyeModal = true;
          break;
        case 'capitalModal':
          this.showCapitalModal = true;
          break;
      }
    }
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .marketplaceAboutContainer {
    .contentMaxWidth {
      max-width: 670px;
    }

    .paragraphContentSection {
      h4 {
        margin-bottom: 35px;
      }
    }

    .largePadding {
      padding: 100px 0;
      @include media-breakpoint-down(sm) {
        padding: 20px 0;
      }
    }

    .ourExpertsWrapper {
      .ourExpertsContent {
        padding: 100px 0 20px;
        @include media-breakpoint-down(sm) {
          padding: 30px 0 10px;
          h4 {
            margin-bottom: 10px;
          }
        }
      }
    }

    .expertsImage {
      max-width: 1440px;
    }

    .doubleStatWrapper {
      @include media-breakpoint-down(sm) {
        width: 100%;
        flex-direction: column;
      }
      .doubleStat {
        margin-bottom: 35px;

        @include media-breakpoint-down(sm) {
          width: 100%;
          border-top: 1px solid $light-gray;
          padding-top: 20px;
        }

        h4 {
          margin-bottom: 10px;
        }
        span {
          color: $corduroy;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.01em;
        }

        &:first-of-type {
          margin-right: 70px;
          @include media-breakpoint-down(sm) {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
